var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('event-list',{attrs:{"issearch":false,"start":_vm.start,"end":_vm.end}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }